import axios from 'axios'

export default {
  async searchCompany(query) {
    const result = await axios.get('SearchBusinessCompanies', {
      params: {
        query,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async createCompany(company) {
    try {
      const result = await axios.post('CreateBusinessCompany', company)
      if (result.status == 200) return result.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async searchLeaseCompanies(query) {
    const result = await axios.get('SearchLeaseCompanies', {
      params: {
        query,
      },
    })

    if (result.status == 200) return result.data

    return []
  },
  async searchNationalCompanies(searchParams) {
    const { phone, cocNumber, zipcode, houseNumber, poIdOrCoC, chamberOfCommerceEstablishment } =
      searchParams

    const result = await axios.get('SearchNationalCompanies', {
      params: {
        phone,
        cocNumber,
        zipcode,
        houseNumber,
        poIdOrCoC,
        chamberOfCommerceEstablishment,
      },
    })
    if (result.status === 200) {
      return result.data
    }

    return []
  },
  convertCompanyToLeaseCompanyDto(company) {
    if (!company) return null

    let leaseCompany = {
      DealerId: null,
      DebtorId: company.CustomerCompanyDebtorId,
      CrmNumber: company.CustomerCompanyMagicNumber,
      CustomerCompanyId: null,
      CustomerId: company.CustomerCompanyPoId,
      Name: company.CustomerCompanyName,
      Address: company.CustomerCompanyAddress,
      ZipCode: company.CustomerCompanyZipcode,
      City: company.CustomerCompanyCity,
      CountryCode: company.CustomerCompanyCountryCode,
      MailingAddress: company.CustomerCompanyMailingAddress,
      MailingCity: null,
      MailingPreference: null,
      MailingCountryCode: null,
      Phonenumber: company.CustomerCompanyPhoneNumber,
      Email: company.CustomerCompanyEmailAddress,
      TaxNumber: null,
      Iban: null,
      RobNumber: null,
      CategoryCode: null,
      AnalyseCode: null,
      Block: null,
      Edm: null,
      ChamberOfCommerceNumber: company.CustomerCompanyChamberOfCommerceNumber,
      CustomerCompanySource: company.CustomerCompanySource,
    }

    return leaseCompany
  },
  async SearchCompanySbiCode(params) {
    try {
      const { poId, companyId, cocNumber } = params
      const result = await axios.get('SearchCompanySbiCode', {
        params: { poId, companyId, cocNumber },
      })

      if (result.status == 200) return result.data

      return []
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
